export default "__VITE_ASSET__D4Inw8go__"